import { observer } from "mobx-react"
import React, { useEffect, useMemo, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import styled from "styled-components"
import flagLV from "icons/flags/flag-LV.svg"
import flagUSA from "icons/flags/flag-USA.svg"
import HyperDiv from "./HyperDiv/HyperDiv"
import { TLanguageValues } from "components/ProjectSpecificComponents/Interfaces/GlobalInterface"
import { useFormStore } from "components/ProjectSpecificComponents/Contexts/FormStoreContext"
import useScreenType from "../Hooks/useScreenType"
import { useOuterClick } from "../Hooks/useOuterClick"

interface LanguageSelectorProps {
	onClose?(): void
	mobile?: boolean
}

export interface ILanguage {
	value: TLanguageValues
	flag: string
	label: string
}

const LanguageSelect = observer(({ onClose, mobile = false }: LanguageSelectorProps) => {
	const formStore = useFormStore()
	const { i18n } = useTranslation()
	const { isMobile } = useScreenType()
	const componentRef = useOuterClick(() => {
		setLanguageSelectOpen(false)
	})
	const options: ILanguage[] = [
		{ value: "en", flag: flagUSA, label: "English" }, // English (Default)
		{ value: "lv", flag: flagLV, label: "Latviešu" }, // Latviešu
	]
	const languages: ILanguage[] = [...options].sort((a, b) => a.label.localeCompare(b.label))

	const [isLanguageSelectOpen, setLanguageSelectOpen] = useState<boolean>(false)

	const toggleLanguageSelect = () => setLanguageSelectOpen((isSelectOpen: boolean) => !isSelectOpen)

	const handleLanguageSelect = (value: TLanguageValues) => {
		toggleLanguageSelect()
		i18n.changeLanguage(value)
		localStorage.setItem("language", JSON.stringify({ value: value }))
		formStore.setAllLanguages(value)
	}

	const currentLanguageSelected: ILanguage = useMemo(() => {
		var _language: ILanguage | undefined
		languages.map(
			(language: ILanguage) => language.value === i18n.language && (_language = language)
		)
		return _language ?? languages[0]
	}, [i18n.language])

	return (
		<HyperDiv direction="column" ref={componentRef as any}>
			<HyperDiv
				direction="row"
				className="pointer px-2 py-2 rounded-md"
				centeredY
				style={{
					// backgroundColor: formStore.settingsData.personalize.colorButtonText,
					color: isMobile
						? "var(--muddy-puddle-gray)"
						: formStore.settingsData.personalize.colorHeaderText,
				}}
				onClick={toggleLanguageSelect}
			>
				<LanguageIcon src={currentLanguageSelected.flag} />
				<i
					className="arrow down"
					style={{
						borderColor: formStore.settingsData.personalize.colorHeaderText ?? "inherit",
					}}
				></i>
			</HyperDiv>

			{isLanguageSelectOpen && (
				<LanguageDropdown>
					{languages.map(({ flag, label, value }: ILanguage) => (
						<React.Fragment key={value + label}>
							<LanguageOption className="center-y" onClick={() => handleLanguageSelect(value)}>
								<LanguageIcon src={flag} /> {label}
							</LanguageOption>
						</React.Fragment>
					))}
				</LanguageDropdown>
			)}
		</HyperDiv>
	)
})

export default LanguageSelect

const LanguageDropdown = styled.div`
	position: fixed;
	z-index: 30;
	transform: translate(-5%, 40%);
	background-color: white;
	border: 1px solid var(--light-gray);
	padding: 2px 0px;
	border-radius: 5px;
`
const LanguageOption = styled.div`
	color: black;
	font-size: 12px;
	font-weight: 300;
	letter-spacing: normal;
	/* margin: 2px 0px; */
	padding: 5px;
	padding-right: 10px;
	border-radius: 2px;
	cursor: pointer;

	:hover {
		background-color: var(--light-light-blue);
	}
`

const LanguageIcon = styled.img`
	width: 20px;
	margin-right: 5px;
	padding: 2px;
	cursor: inherit;
`
